import {
  Box,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
} from "@mui/material";
import { iDataOrganizacion } from "../../interfaces/SuperAdmin/Pages/iDataOrganizacion";
import { Controller, useForm } from "react-hook-form";

interface Props {
  organizaciones: iDataOrganizacion[];
  selectedOrg: string;
  handleChange: (event: SelectChangeEvent) => void;
  isLoading: boolean;
}

const SuscrPickOrg: React.FC<Props> = ({
  organizaciones,
  selectedOrg,
  handleChange,
  isLoading,
}) => {
  const { control, handleSubmit } = useForm();
  return (
    <Grid
      item
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
      }}
    >
      <Typography
        sx={{
          fontFamily: "Montserrat",
          fontSize: "16px",
          color: "#336B87",
          fontWeight: "bold",
        }}
      >
        1. Seleccionar organización
      </Typography>
      {isLoading ? (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          height="100%"
        >
          <CircularProgress />
        </Box>
      ) : (
        <Controller
          name="Organización"
          control={control}
          defaultValue={selectedOrg}
          render={({ field }) => (
            <FormControl sx={{ width: "400px" }}>
              <InputLabel>Selecciona una organización</InputLabel>
              <Select
                {...field}
                onChange={(event) => {
                  field.onChange(event); // Mantiene la integración con react-hook-form
                  handleChange(event); // Llama a la función externa para actualizar el estado global
                }}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 300,
                      overflowY: "auto",
                    },
                  },
                }}
                label="Selecciona una organización"
              >
                {organizaciones.map((org) => (
                  <MenuItem
                    key={org.id_organizacion}
                    value={org.id_organizacion}
                  >
                    {org.nombre}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        />
      )}
    </Grid>
  );
};

export default SuscrPickOrg;
